import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import __ from '../../helpers/translation';

const propTypes = {
  auth: PropTypes.object.isRequired
};

class Navigation extends Component {


  render () {
    return (
      <div className="container-fluid bgwhite menu-bottom tw-z-10">
          <div className="container d-flex flex-row justify-content-center">
              <NavLink
                  to='/home'
                  className="">
                  <img src={window.App.baseUrl + "assets/app/img/bs_inspectie.png"}
                    alt={ __('app.navigation.inspections') } />
                  { __('app.navigation.inspections') }
              </NavLink>
              <NavLink
                  to='/companies'
                  className="position-relative">
                  <img src={window.App.baseUrl + "assets/app/img/bs_opdrachtgever.png"}
                    alt={ __('app.navigation.companies') }
                    className="active orange" />
                    {this.props.auth.user && this.props.auth.user.new_connections ? 
                      (<span className="notification-count">{this.props.auth.user.new_connections}</span>)
                      : ('')
                    }
                  { __('app.navigation.companies') } 
              </NavLink>
              <NavLink
                  to='/profile'
                  className="">
                  <img src={window.App.baseUrl + "assets/app/img/bs_profiel.png"}
                    alt={ __('app.navigation.profile') } />
                  { __('app.navigation.profile') }
              </NavLink>
          </div>
      </div>
    );
  }
}

Navigation.propTypes = propTypes;

const mapStateToProps = ({ auth }) => ({ auth });

export default connect(mapStateToProps)(Navigation);